export default "__VITE_ASSET__CbwA3pgq__"